import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";

import { ApplicationState } from "../../../store/ApplicationState";
import { getNotesList, getNotesView, getNotesViewByDisciplineNoteId } from "../../../actions/AuthorizationDetailsTab";
import Notes from "../components/Notes";
import { NotesListDispatchTypes } from "../../../models/DispatchTypes/AuthorizationDetailstab";


const mapStateToProps = ({
  notesListState,
  notesViewState
}: ApplicationState) => ({
  notesListState: notesListState.response,
  notesViewState: notesViewState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, NotesListDispatchTypes>
) => {
    return {
      getNotesList: (referralId: number) => {
        dispatch(getNotesList(referralId));
      },
      getNotesView: (referralNoteId: number) => {
        dispatch(getNotesView(referralNoteId));
      },
      getNotesViewByDisciplineNoteId: (disciplineNoteId: number) => {
        dispatch(getNotesViewByDisciplineNoteId(disciplineNoteId));
      }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
